<div class="card">
    <h1>
        <naming-convention-label [type]="'Org'" [singular]="true"></naming-convention-label>
        Details
    </h1>

    <form *miproLoading="loadingOrganization" [formGroup]="organizationForm" (ngSubmit)="save()">
        <p-tabView>
            <p-tabPanel header="Basic Details" class="inputs-group">
                <div class="inputs-group-row no-label-padding">
                    <span class="inputs-group-row-name asterisk-mark pl-10">Gov. Body:</span>
                    <div *ngIf="!isCreate; else selectGovBody" class="inputs-group-row-value">
                        {{ governingBodyName }}
                    </div>
                    <ng-template #selectGovBody>
                        <div class="inputs-group-row-value">
                            <p-dropdown formControlName="governingBodyId"
                                        [options]="govBodyOptions"
                                        [showClear]="true"
                                        appendTo="body"
                                        (onChange)="onGoverningBodyChange($event.value)"
                                        placeholder="Select GovBody">
                            </p-dropdown>
                            <control-errors [control]="organizationForm.get('governingBodyId')"></control-errors>
                        </div>
                    </ng-template>
                </div>

                <div class="inputs-group-row no-label-padding">
                    <span class="inputs-group-row-name pl-10">Organisation Type:</span>
                    <div *ngIf="sportTypeName !== null; else noneTempl" class="inputs-group-row-value">
                        {{ sportTypeName }}
                    </div>
                </div>

                <ng-template #noneTempl>
                    <div class="inputs-group-row-value gray-text">None</div>
                </ng-template>

                <div class="inputs-group-row">
                    <label class="inputs-group-row-name asterisk-mark pl-10">Name:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="name" pInputText />
                        <control-errors [control]="organizationForm.get('name')"
                                        [errors]="{ companyExist: 'Another organisation with this name already exists' }"></control-errors>
                    </div>
                </div>

                <div class="inputs-group-row">
                    <label class="inputs-group-row-name pl-10">External ID:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="externalId" pInputText />
                        <control-errors [control]="organizationForm.get('externalId')"
                                        [errors]="{ externalIdExist: 'Another organisation with this External ID already exists' }"></control-errors>
                    </div>
                </div>

                <ng-container formGroupName="address">
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark pl-10">Address 1:</label>
                        <div class="inputs-group-row-value">
                            <input formControlName="address1" pInputText id="address1" />
                            <control-errors [control]="organizationForm.get('address.address1')"></control-errors>
                        </div>
                    </div>

                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name pl-10">Address 2:</label>
                        <div class="inputs-group-row-value">
                            <input formControlName="address2" pInputText />
                            <control-errors [control]="organizationForm.get('address.address2')"></control-errors>
                        </div>
                    </div>

                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name pl-10">Address 3:</label>
                        <div class="inputs-group-row-value">
                            <input formControlName="address3" pInputText />
                        </div>
                    </div>

                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name pl-10">Address 4:</label>
                        <div class="inputs-group-row-value">
                            <input formControlName="address4" pInputText />
                        </div>
                    </div>

                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark pl-10">Post code:</label>
                        <div class="inputs-group-row-value">
                            <input formControlName="postCode" pInputText />
                            <control-errors [control]="organizationForm.get('address.postCode')"></control-errors>
                        </div>
                    </div>
                </ng-container>

                <div class="inputs-group-row">
                    <label class="inputs-group-row-name asterisk-mark pl-10">Phone No.:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="phoneNumber" pInputText />
                        <control-errors [control]="organizationForm.get('phoneNumber')"
                                        [errors]="{ pattern: 'The phone number is invalid' }"></control-errors>
                    </div>
                </div>

                <div class="inputs-group-row">
                    <label class="inputs-group-row-name pl-10">Notes:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="description" pInputText />
                    </div>
                </div>

                <div class="inputs-group-row">
                    <div class="inputs-group-row-name pl-10">Mandatory 2FA:</div>
                    <ng-container *ngIf="enableMandatoryTwoFactorAuthCheckbox; else checkedDisabledCheckbox">
                        <div class="inputs-group-row-value pl-20">
                            <p-checkbox [binary]="true"
                                        [value]="parentMandatoryTwoFactorAuth"
                                        formControlName="mandatoryTwoFactorAuth">
                            </p-checkbox>
                        </div>
                    </ng-container>
                    <ng-template #checkedDisabledCheckbox>
                        <div class="inputs-group-row-value pl-20">
                            <p-checkbox [ngModel]="true" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="true" [binary]="true">
                            </p-checkbox>
                        </div>
                        <p *ngIf="cqcRegistrationNumber?.value" style="margin: 10px; font-size: 0.95rem">
                            <i>The NHS login Module is enabled</i>
                        </p>
                    </ng-template>
                </div>

                <system-code-edit *ngIf="hasManageOrganisationSystemCode"
                                  [overrideSystemCodeType]="overrideSystemCodeType"
                                  [parentCanOrganisationsOverrideSystemCodeType]="parentCanOrganisationsOverrideSystemCodeType"
                                  [systemCodeType]="systemCodeType"
                                  [disableDropdown]="!overrideSystemCodeType"
                                  (changedOverrideSwitch)="changeOverrideSystemCodeType($event)"
                                  (changedSystemCode)="changeSystemCodeType($event)"></system-code-edit>

                <p-panel header="Duplicate Patient Check">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overrideDuplicatePatientCheckType"
                                       (onChange)="changeOverrideDuplicatePatientCheckType($event.checked)"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark">Duplicate Patient Check Type:</label>
                        <div class="inputs-group-row-value">
                            <p-dropdown [disabled]="!overrideDuplicatePatientCheckType"
                                        formControlName="duplicatePatientCheckType"
                                        [options]="duplicatePatientCheckTypeOptions"
                                        [showClear]="false"
                                        appendTo="body"
                                        placeholder="Select Duplicate Patient Check Type">
                            </p-dropdown>
                            <control-errors [control]="organizationForm.get('duplicatePatientCheckType')">
                            </control-errors>
                        </div>
                    </div>
                </p-panel>

                <p-panel header="Months Until Episodes Become Inactive">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overrideMonthsUntilEpisodeInactive"
                                       (onChange)="changeOverrideMonthsUntilEpisodeInactive($event.checked)"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark">
                            Months Until Episodes Become Inactive:
                        </label>
                        <div class="inputs-group-row-value">
                            <input pInputText
                                   type="number"
                                   pattern="[1-9][0-9]*"
                                   formControlName="monthsUntilEpisodeInactive"
                                   [readonly]="!overrideMonthsUntilEpisodeInactive" />
                            <control-errors [control]="organizationForm.get('monthsUntilEpisodeInactive')">
                            </control-errors>
                        </div>
                    </div>
                </p-panel>

                <p-panel header="Passport Data Sharing">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overridePassportDataSharing"
                                       (onChange)="changeOverridePassportDataSharing($event.checked)"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark">Passport can see Organisation data:</label>
                        <div class="inputs-group-row-value">
                            <p-checkbox [binary]="true" formControlName="passportDataSharing"
                                        [disabled]="!overridePassportDataSharing">
                            </p-checkbox>
                            <control-errors [control]="organizationForm.get('passportDataSharing')"></control-errors>
                        </div>
                    </div>
                </p-panel>

                <p-panel header="Auto Approve Self-Registration">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overrideAutoApproveSelfRegisteredPatients"
                                       (onChange)="changeOverrideAutoApproveSelfRegisteredPatients($event.checked)"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark">
                            Automatically approve Self-Registered Patients:
                        </label>
                        <div class="inputs-group-row-value multiple-items">
                            <div class="multiple-items">
                                <div class="item-1">
                                    <p-checkbox [binary]="true"
                                                formControlName="autoApproveSelfRegisteredPatients"
                                                [disabled]="!overrideAutoApproveSelfRegisteredPatients">
                                    </p-checkbox>
                                    <control-errors [control]="organizationForm.get('autoApproveSelfRegisteredPatients')">
                                    </control-errors>
                                </div>
                                <div class="item-2">
                                    <p-dropdown #autoApproveTypeDropdown
                                        [disabled]="!organizationForm.get('autoApproveSelfRegisteredPatients').value"
                                                formControlName="autoApproveType"
                                                [options]="autoApproveOptions"
                                                [showClear]="false"
                                                appendTo="body"
                                                placeholder="Auto-Approve">
                                    </p-dropdown>
                                    <control-errors [control]="organizationForm.get('duplicatePatientCheckType')">
                                    </control-errors>
                                </div>
                            </div>
                        </div>

                    </div>
                </p-panel>

                <p-panel header="Mandatory Identity Verification">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overrideMandatoryIdentityVerification"
                                       (onChange)="changeOverrideMandatoryIdentityVerification($event.checked)"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name asterisk-mark">Mandatory Identity Verification:</label>
                        <div class="inputs-group-row-value">
                            <p-checkbox [binary]="true"
                                        formControlName="mandatoryIdentityVerification"
                                        [disabled]="!overrideMandatoryIdentityVerification">
                            </p-checkbox>
                            <control-errors [control]="organizationForm.get('mandatoryIdentityVerification')">
                            </control-errors>
                        </div>
                    </div>
                </p-panel>

                <p-panel [header]="ResearchOptHeader">
                    <ng-template pTemplate="icons">
                        <p-checkbox [binary]="true" formControlName="researchOptOut"></p-checkbox>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label style="font-size: 13px; color: rgba(0, 0, 0, 0.6); display: block; margin-top: 10px; text-align: left;"
                               [innerHTML]="ResearchOptMessage">
                        </label>
                    </div>
                </p-panel>

                <p-panel header="Patient Review">
                    <ng-template pTemplate="icons">
                        <label class="mr-2">Override:</label>
                        <p-inputSwitch formControlName="overrideEnablePatientPsdConfirmation"></p-inputSwitch>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label class="inputs-group-row-name">Enable Patient PSD Confirmation/Link:</label>
                        <div class="inputs-group-row-value">
                            <p-checkbox [binary]="true"
                                        formControlName="enablePatientPsdConfirmation"
                                        [disabled]="!overrideEnablePatientPsdConfirmation">
                            </p-checkbox>
                        </div>
                    </div>
                </p-panel>

                <p-panel header="Organisational Auto Data Sharing">
                    <ng-template pTemplate="icons">
                        <p-checkbox [binary]="true" formControlName="autoApproveDataSharing"></p-checkbox>
                    </ng-template>
                    <div class="inputs-group-row">
                        <label
                            style="font-size: 13px; color: rgba(0, 0, 0, 0.6); display: block; margin-top: 10px; text-align: left;"
                            [innerHTML]="autoApproveDataSharingMessage">
                        </label>
                    </div>
                </p-panel>

                <ng-container [ngTemplateOutlet]="formButtons"></ng-container>
            </p-tabPanel>
            <p-tabPanel header="Enable Modules" class="inputs-group">
                <h1>Enable Modules</h1>
                <ng-container formArrayName="enabledModules">
                    <ng-container *ngFor="let em of enabledModules.controls">
                        <ng-container [ngSwitch]="em.value.moduleName">
                            <ng-container *ngSwitchCase="miproModules.Consultations">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <ng-template>
                                        <div class="inputs-group-row" [formGroup]="organizationForm">
                                            <div class="inputs-group-row-name">Enable Patient Document Upload:
                                            </div>
                                            <div class="inputs-group-row-value" style="padding-top: 0.6875rem;">
                                                <p-inputSwitch formControlName="enablePatientDocumentUpload"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </ng-template>
                                </enabled-module>
                            </ng-container>
                            <ng-container *ngSwitchCase="miproModules.Diary">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <ng-template>
                                        <div class="inputs-group-row" [formGroup]="organizationForm">
                                            <div class="inputs-group-row-name">Show Diary LHS Menu and Home Page CARD:
                                            </div>
                                            <div class="inputs-group-row-value" style="padding-top: 0.6875rem;">
                                                <p-inputSwitch formControlName="diaryModuleVisibleLHSAndCard"></p-inputSwitch>
                                            </div>
                                        </div>
                                        <p-panel
                                            *ngIf="showSelfRegistrationURLField"
                                            [formGroup]="organizationForm"
                                            header="Self Register Patient URL"
                                            class="self-register-url mt-2 mb-2">
                                            <ng-template pTemplate="icons">
                                                <a *ngIf="selfRegisterPatientUrlEnabled?.value"> ON </a>
                                                <a *ngIf="!selfRegisterPatientUrlEnabled?.value"> OFF </a>
                                                <p-inputSwitch formControlName="selfRegisterPatientURLEnabled" (onChange)="onSelfRegPatientUrlEnabled($event.checked)">
                                                </p-inputSwitch>
                                            </ng-template>
                                            <ng-container>
                                                <div class="inputs-group-row">
                                                    <m-copy-value *ngIf="selfRegisterPatientURL"
                                                                  [value]="selfRegisterPatientURL"></m-copy-value>
                                                    <i *ngIf="!selfRegisterPatientURL">Not defined yet</i>
                                                </div>
                                                <ng-container *ngIf="selfRegisterPatientUrlEnabled?.value">
                                                    <p-divider><b>Welcome screen</b></p-divider>

                                                    <div class="inputs-group-row mt-3">
                                                        <div class="inputs-group-row-name">Register Option:</div>
                                                        <div class="inputs-group-row-value" (afterLoad)="refreshSelfRegisterPatientUrlLoginMode()">
                                                            <p-radioButton #selfRegLoginMode
                                                                           formControlName="selfRegisterPatientUrlLoginMode"
                                                                           [value]="SelfRegisterLoginMode.MiProAndNhs"
                                                                           [disabled]="!isNhsModuleEnabled"
                                                                           label="ORB login & NHS login"
                                                                           class="inputs-group-row-value-item">
                                                            </p-radioButton>
                                                            <p-radioButton #selfRegLoginMode
                                                                           formControlName="selfRegisterPatientUrlLoginMode"
                                                                           [value]="SelfRegisterLoginMode.MiPro"
                                                                           label="ORB login"
                                                                           class="inputs-group-row-value-item">
                                                            </p-radioButton>
                                                            <p-radioButton #selfRegLoginMode
                                                                           formControlName="selfRegisterPatientUrlLoginMode"
                                                                           [value]="SelfRegisterLoginMode.Nhs"
                                                                           [disabled]="!isNhsModuleEnabled"
                                                                           label="NHS login"
                                                                           class="inputs-group-row-value-item">
                                                            </p-radioButton>
                                                        </div>
                                                    </div>

                                                    <div class="inputs-group-row">
                                                        <label class="inputs-group-row-name">Welcome Message Title:</label>
                                                        <div class="inputs-group-row-value">
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                formControlName="selfRegisterPatientWelcomeTitle" />
                                                        </div>
                                                    </div>
                                                    <div class="inputs-group-row">
                                                        <label class="inputs-group-row-name">Welcome Message Subtitle:</label>
                                                        <div class="inputs-group-row-value">
                                                            <textarea pInputTextarea formControlName="selfRegisterPatientWelcomeSubtitle"></textarea>
                                                        </div>
                                                    </div>

                                                    <p-divider/>

                                                    <div class="inputs-group-row">
                                                        <div class="inputs-group-row-name">Save External Patient ID:
                                                        </div>
                                                        <div class="inputs-group-row-value" style="padding-top: 0.6875rem;">
                                                            <p-inputSwitch
                                                                formControlName="externalPatientIdSavingEnabled"></p-inputSwitch>
                                                        </div>
                                                    </div>

                                                    <p-divider><b>Redirect Banner</b></p-divider>

                                                    <div class="inputs-group-row">
                                                        <div class="inputs-group-row-name">Show Redirect Banner:
                                                        </div>
                                                        <div class="inputs-group-row-value" style="padding-top: 0.6875rem;">
                                                            <p-inputSwitch
                                                                formControlName="externalSiteRedirectBannerEnabled"></p-inputSwitch>
                                                        </div>
                                                    </div>
                                                    <div class="inputs-group-row" *ngIf="organizationForm.get('externalSiteRedirectBannerEnabled')?.value">
                                                        <label class="inputs-group-row-name">Redirect URL:</label>
                                                        <div class="inputs-group-row-value">
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                formControlName="externalSiteURL"/>
                                                            <control-errors
                                                                [control]="organizationForm.get('externalSiteURL')"
                                                                [errors]="{ invalidUrl: 'Invalid URL' }"></control-errors>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngIf="organizationForm.controls.externalSiteRedirectBannerEnabled?.value">
                                                        <div class="inputs-group-row">
                                                            <div class="inputs-group-row-name">Banner Body:</div>
                                                        </div>
                                                        <div class="inputs-group-row">
                                                            <p-editor
                                                                formControlName="externalSiteRedirectBannerBody"
                                                                [style]="{height: '250px'}">
                                                            </p-editor>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </p-panel>
                                        <p-panel
                                            *ngIf="showAppointmentBookingURLField"
                                            [formGroup]="organizationForm"
                                            header="Appointment Booking URL"
                                            class="appointment-booking-url mt-2 mb-2">
                                            <ng-template pTemplate="icons">
                                                <a *ngIf="appointmentBookingURLEnabled?.value"> ON </a>
                                                <a *ngIf="!appointmentBookingURLEnabled?.value"> OFF </a>
                                                <p-inputSwitch formControlName="appointmentBookingURLEnabled">
                                                </p-inputSwitch>
                                            </ng-template>
                                            <ng-container>
                                                <div class="inputs-group-row">
                                                    <m-copy-value *ngIf="appointmentBookingURL"
                                                                [value]="appointmentBookingURL"></m-copy-value>
                                                    <i *ngIf="!appointmentBookingURL">Not defined yet</i>
                                                </div>
                                            </ng-container>
                                        </p-panel>
                                    </ng-template>
                                </enabled-module>
                            </ng-container>

                            <ng-container *ngSwitchCase="miproModules.FunctionalGut">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <p-panel *ngIf="organizationForm" [formGroup]="organizationForm" header="Unique Global URL">
                                        <ng-container>
                                            <m-copy-value [value]="globalURL"></m-copy-value>
                                            <i *ngIf="!globalURL">Not defined yet</i>
                                        </ng-container>

                                        <div class="inputs-group-row">
                                            <label class="inputs-group-row-name asterisk-mark">Global Password:</label>
                                            <div class="inputs-group-row-value">
                                                <input id="passwordInput" formControlName="password" type="Text"/>
                                            </div>
                                        </div>
                                    </p-panel>
                                </enabled-module>
                            </ng-container>

                            <ng-container *ngSwitchCase="miproModules.Prescriptions">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <p-panel
                                        header="Preferred Supplier Details"
                                        [formGroup]="preferredPharmacy"
                                        [toggleable]="true"
                                        *role="[coreRoles.MiProAdmin, coreRoles.SuperAdmin]">
                                        <ng-template pTemplate="icons">
                                            <button
                                                pTooltip="Clear Preferred Pharmacy Details"
                                                tooltipPosition="top"
                                                type="button"
                                                class="p-panel-header-icon p-link mr-2"
                                                (click)="clearPreferredPharmacyForm()">
                                                <span class="mi mi-button-remove text-danger"></span>
                                            </button>
                                        </ng-template>

                                        <m-control-group label="Pharmacy Name"
                                                         [required]="preferredPharmacyRequiredFields">
                                            <m-text-control formControlName="name"></m-text-control>
                                            <control-errors control="name"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Email"
                                                         [required]="preferredPharmacyRequiredFields">
                                            <m-text-control formControlName="email"></m-text-control>
                                            <control-errors control="email"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Address Line 1"
                                                         [required]="preferredPharmacyRequiredFields">
                                            <m-text-control formControlName="addressLine1"></m-text-control>
                                            <control-errors control="addressLine1"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Address Line 2"
                                                         [required]="preferredPharmacyRequiredFields">
                                            <m-text-control formControlName="addressLine2"></m-text-control>
                                            <control-errors control="addressLine2"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Address Line 3">
                                            <m-text-control formControlName="addressLine3"></m-text-control>
                                            <control-errors control="addressLine3"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Address Line 4">
                                            <m-text-control formControlName="addressLine4"></m-text-control>
                                            <control-errors control="addressLine4"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Post code"
                                                         [required]="preferredPharmacyRequiredFields">
                                            <m-text-control formControlName="postCode"></m-text-control>
                                            <control-errors control="postCode"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Phone No">
                                            <m-text-control formControlName="phoneNumber"></m-text-control>
                                            <control-errors control="phoneNumber"></control-errors>
                                        </m-control-group>

                                        <m-control-group label="Pharmacy Notes">
                                            <textarea pInputTextarea formControlName="notes"></textarea>
                                        </m-control-group>
                                    </p-panel>

                                    <p-panel header="Enable Signature Rx"
                                             [formGroup]="organizationForm"
                                             *role="[coreRoles.MiProAdmin, coreRoles.SuperAdmin]">
                                        <ng-template pTemplate="icons">
                                            @if (signatureRxEnabled()) {
                                                <a> ON </a>
                                            } @else {
                                                <a> OFF </a>
                                            }
                                            <p-inputSwitch formControlName="signatureRxEnabled">
                                            </p-inputSwitch>
                                        </ng-template>
                                        <ng-container >
                                            <div [formGroup]="srxCredentialsForm" [hidden]="!signatureRxEnabled()">
                                                <div class="inputs-group-row">
                                                    <div class="inputs-group-row-name pb-1">Organization Webhook URL:</div>

                                                    <div>
                                                        @if (organizationWebhookUrl()) {
                                                            <m-copy-value [value]="organizationWebhookUrl()"></m-copy-value>
                                                        } @else {
                                                            <i>Not defined yet</i>
                                                        }
                                                    </div>
                                                </div>

                                                <div class="inputs-group-row">
                                                    <label class="inputs-group-row-name">Signature Rx Webhook Secret:</label>
                                                    <div [formGroup]="organizationForm" class="inputs-group-row-value">
                                                        <input
                                                            pInputText
                                                            type="text"
                                                            class="mask-text"
                                                            autocomplete="off"
                                                            formControlName="srxWebhookSecret"
                                                            [placeholder]="srxWebhookSecretIsSaved() ? '•••••••••••••' : ''" />
                                                        <control-errors
                                                            [control]="organizationForm.get('srxWebhookSecret')"
                                                            [errors]="{ pattern: 'The Signature Rx Webhook key should have format: \'whsec_[60 symbols]\'' }"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div [formGroup]="srxCredentialsForm" [hidden]="!signatureRxEnabled()">
                                                <p-divider><b>Signature Rx JWT API Credentials</b></p-divider>

                                                <div class="inputs-group-row">
                                                    <label class="inputs-group-row-name">Email:</label>
                                                    <div class="inputs-group-row-value">
                                                        <input
                                                            pInputText
                                                            type="text"
                                                            formControlName="signatureRxApiEmail" />
                                                    </div>
                                                </div>

                                                <div class="inputs-group-row">
                                                    <label class="inputs-group-row-name">Password:</label>
                                                    <div class="inputs-group-row-value">
                                                        <input
                                                            pInputText
                                                            type="text"
                                                            class="mask-text"
                                                            autocomplete="off"
                                                            formControlName="signatureRxApiPassword"
                                                            [placeholder]="srxPasswordIsSaved() ? '•••••••••••••' : ''" />
                                                    </div>
                                                </div>

                                                <div class="flex align-items-center">
                                                    <button
                                                        pButton
                                                        type="button"
                                                        [loading]="savingSrxCredentials()"
                                                        [disabled]="savingSrxCredentials() || !srxCredentialsForm.valid"
                                                        label="Save"
                                                        class="p-button-primary mb-1"
                                                        (click)="saveSrxApiCredentials()">
                                                    </button>

                                                    <button
                                                        pButton
                                                        type="button"
                                                        [loading]="testingSrxCredentials()"
                                                        label="Test"
                                                        class="p-button-primary ml-2 mb-1"
                                                        (click)="onTestSrxApiPressed()">
                                                    </button>

                                                    @if (srxCredentialsStatusResponse() === SrxCredentialsStatus.SrxCredentialsTestSuccess) {
                                                        <div class="ml-2">Login Successful ✅</div>
                                                    } @else if (srxCredentialsStatusResponse() === SrxCredentialsStatus.SrxCredentialsTestFailed) {
                                                        <div class="ml-2 text-red-500">Login Failed ❌</div>
                                                    } @else if (srxCredentialsStatusResponse() === SrxCredentialsStatus.SrxCredentialsSaveSuccess) {
                                                        <div class="ml-2">Credentials Saved Successfully ✅</div>
                                                    } @else if (srxCredentialsStatusResponse() === SrxCredentialsStatus.SrxCredentialsSaveFailed) {
                                                        <div class="ml-2 text-red-500">Credentials Can't Be Saved ❌</div>
                                                    }
                                                </div>
                                            </div>
                                            <div [formGroup]="srxOAuth2CredentialsForm" [hidden]="!signatureRxEnabled()">
                                                <p-divider><b>Signature Rx OAuth2 API Credentials</b></p-divider>

                                                <div class="inputs-group-row">
                                                    <label class="inputs-group-row-name">Client ID:</label>
                                                    <div class="inputs-group-row-value">
                                                        <input
                                                            pInputText
                                                            type="text"
                                                            formControlName="signatureRxOAuth2ClientId" />
                                                    </div>
                                                </div>

                                                <div class="inputs-group-row">
                                                    <label class="inputs-group-row-name">Client Secret:</label>
                                                    <div class="inputs-group-row-value">
                                                        <input
                                                            pInputText
                                                            type="text"
                                                            class="mask-text"
                                                            autocomplete="off"
                                                            formControlName="signatureRxOAuth2ClientSecret"
                                                            [placeholder]="oAuth2ClientSecretIsSaved() ? '•••••••••••••' : ''" />
                                                    </div>
                                                </div>

                                                <div class="flex align-items-center">
                                                    <button
                                                        pButton
                                                        type="button"
                                                        [loading]="savingOAuth2Credentials()"
                                                        [disabled]="savingOAuth2Credentials() || !srxOAuth2CredentialsForm.valid"
                                                        label="Save"
                                                        class="p-button-primary mb-1"
                                                        (click)="saveOAuth2Credentials()">
                                                    </button>

                                                    <button
                                                        pButton
                                                        type="button"
                                                        [loading]="testingOAuth2Credentials()"
                                                        label="Test"
                                                        class="p-button-primary ml-2 mb-1"
                                                        (click)="onTestOAuth2CredentialsPressed()">
                                                    </button>

                                                    @if (oAuth2CredentialsStatusResponse() === SrxCredentialsStatus.SrxOAuth2TestSuccess) {
                                                        <div class="ml-2">OAuth2 Test Successful ✅</div>
                                                    } @else if (oAuth2CredentialsStatusResponse() === SrxCredentialsStatus.SrxOAuth2TestFailed) {
                                                        <div class="ml-2 text-red-500">OAuth2 Test Failed ❌</div>
                                                    } @else if (oAuth2CredentialsStatusResponse() === SrxCredentialsStatus.SrxOAuth2SaveSuccess) {
                                                        <div class="ml-2">OAuth2 Credentials Saved Successfully ✅</div>
                                                    } @else if (oAuth2CredentialsStatusResponse() === SrxCredentialsStatus.SrxOAuth2SaveFailed) {
                                                        <div class="ml-2 text-red-500">OAuth2 Credentials Can't Be Saved ❌</div>
                                                    }
                                                </div>
                                            </div>
                                        </ng-container>
                                    </p-panel>
                                </enabled-module>
                            </ng-container>

                            <ng-container *ngSwitchCase="miproModules.Reporting">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <p-panel
                                        *ngIf="showSystemDashboards"
                                        [formGroup]="organizationForm"
                                        header="System Dashboards"
                                        [toggleable]="true">

                                        <div class="inputs-group-row">
                                            <m-control-group label="Clinician Homepage">
                                                <p-dropdown
                                                    formControlName="homeClinicianDashboardId"
                                                    [options]="dashboardOptions"
                                                    [showClear]="true"
                                                    appendTo="body"
                                                    placeholder="Clinician Dashboard">
                                                </p-dropdown>
                                            </m-control-group>

                                            <div class="inputs-group-row flex align-items-end">
                                                <label class="inputs-group-row-name">Clinician Homepage Type:</label>
                                                <div class="inputs-group-row-value">
                                                    <div class="flex align-items-center">
                                                        <span class="mr-2">Default</span>
                                                        <p-inputSwitch
                                                            formControlName="clinicianDefaultHomeScreenMode"
                                                            [falseValue]="HomeScreenMode.Cards"
                                                            [trueValue]="HomeScreenMode.Dashboard">
                                                        </p-inputSwitch>
                                                        <span class="ml-2">Custom</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <m-control-group label="Patient Homepage">
                                                <p-dropdown
                                                    formControlName="homePatientDashboardId"
                                                    [options]="dashboardOptions"
                                                    [showClear]="true"
                                                    appendTo="body"
                                                    placeholder="Patient Dashboard">
                                                </p-dropdown>
                                            </m-control-group>

                                            <div class="inputs-group-row flex align-items-end">
                                                <label class="inputs-group-row-name">Patient Homepage Type:</label>
                                                <div class="inputs-group-row-value">
                                                    <div class="flex align-items-center">
                                                        <span class="mr-2">Cards</span>
                                                        <p-inputSwitch
                                                            formControlName="patientDefaultHomeScreenMode"
                                                            [falseValue]="HomeScreenMode.Cards"
                                                            [trueValue]="HomeScreenMode.Dashboard">
                                                        </p-inputSwitch>
                                                        <span class="ml-2">Dashboard</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <m-control-group label="Selected Patient Homepage">
                                                <p-dropdown
                                                    formControlName="homeSelectedPatientDashboardId"
                                                    [options]="dashboardOptions"
                                                    [showClear]="true"
                                                    appendTo="body"
                                                    placeholder="Selected Patient Dashboard">
                                                </p-dropdown>
                                            </m-control-group>
                                        </div>
                                    </p-panel>
                                </enabled-module>
                            </ng-container>

                            <ng-container *ngSwitchCase="miproModules.NHS">
                                <enabled-module [formControl]="em" (enabledChange)="onModuleEnabledChange($event)">
                                    <p-panel
                                        *ngIf="showNHSAlertsSettings"
                                        [formGroup]="organizationForm"
                                        header="Email/Alerts for Patient NHS Access Status"
                                        class="self-register-url mt-2 mb-2">
                                        <ng-template pTemplate="icons">
                                            <a *ngIf="organizationForm.get('sendNHSAccessStatusAlerts').value">ON</a>
                                            <a *ngIf="!organizationForm.get('sendNHSAccessStatusAlerts').value">OFF</a>
                                            <p-inputSwitch formControlName="sendNHSAccessStatusAlerts">
                                            </p-inputSwitch>
                                        </ng-template>
                                        <div *ngIf="organizationForm.get('sendNHSAccessStatusAlerts').value" class="inputs-group-row mt-2">
                                            <label class="inputs-group-row-name">Select User</label>
                                            <div class="inputs-group-row-value">
                                                <p-dropdown
                                                    [options]="usersInOrganization"
                                                    formControlName="nhsAccessStatusAlertUserId"
                                                    [disabled]="!organizationForm.get('sendNHSAccessStatusAlerts').value"
                                                    placeholder="Select a user"
                                                    appendTo="body"
                                                ></p-dropdown>
                                            </div>
                                        </div>
                                    </p-panel>
                                </enabled-module>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <enabled-module
                                    [formControl]="em"
                                    (enabledChange)="onModuleEnabledChange($event)"
                                    (onDeleteModule)="deleteModule($event)"
                                    (disableNhsAccepted)="lockSelfRegLoginMode()"
                                    [organizationId]="organizationId">
                                </enabled-module>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container [ngTemplateOutlet]="formButtons"></ng-container>
            </p-tabPanel>
            <p-tabPanel *ngIf="!isCreate">
                <ng-template pTemplate="header">
                    <naming-convention-label [type]="'Group'"></naming-convention-label>
                </ng-template>
                <squads-grid [companyId]="organizationForm.get('id').value"></squads-grid>
            </p-tabPanel>

            <p-tabPanel header="Form Events" *ngIf="!isCreate && isFormsModuleEnabled">
                <form-events
                    [governingBodyId]="governingBodyId"
                    [organizationId]="organizationId">
                </form-events>
            </p-tabPanel>
            <p-tabPanel header="Branding" *ngIf="userHelperService.isTopAdmin" class="inputs-group">
                <div class="inputs-group-row" [formGroup]="organizationForm">
                    <div class="inputs-group-row-name">Show ORB Branding:
                    </div>
                    <div class="inputs-group-row-value" style="padding-top: 0.6875rem;">
                        <p-inputSwitch formControlName="showMiProBranding"></p-inputSwitch>
                    </div>
                </div>
                <p-panel
                    [formGroup]="organizationForm"
                    header="Organisation Branding">
                    <div class="logo-row inputs-group-row">
                        <label for="imageUploader" class="inputs-group-row-name">Upload Logo:</label>
                        <div class="inputs-group-row-value inputs-group-row-value-uploader mt-2">
                            <p-fileUpload #logoImageUploader
                                          id="imageUploader"
                                          name="logoImageFiles[]"
                                          mode="basic"
                                          accept=".png,.jpg,.jpeg,.svg"
                                          [maxFileSize]="maxLogoFileSize"
                                          invalidFileSizeMessageDetail="maximum upload size is 1MB."
                                          [auto]="true"
                                          (uploadHandler)="logoImageUploading($event)"
                                          (onError)="onLogoImageUploadingError($event)"
                                          [customUpload]="true">
                            </p-fileUpload>
                            <div *ngIf="logoImageUrl || brandingLogoImageFormData"
                                 class="inputs-group-row-value-uploader-preview-container mt-2">
                                <img [src]="logoImageUrl ?? brandingLogoImagePreviewSrc"
                                     class="inputs-group-row-value-uploader-preview-image p-1 max-h-24rem max-w-24rem"
                                     style="background-color: #ddd;">
                                <p-button icon="mi mi-button-remove"
                                          class="mx-2"
                                          (onClick)="clearLogoImage()">
                                </p-button>
                            </div>
                            <div class="inputs-group-row-value-uploader-description mt-2">
                                This graphic must be supplied in PNG,JPEG or SVG formats. File size must not exceed 1Mb.
                                Recommended proportions are 10x3 (e.g. 250x75 pixels). We also recommend a transparent
                                background.
                            </div>
                        </div>
                    </div>
                </p-panel>
                <ng-container [ngTemplateOutlet]="formButtons"></ng-container>
            </p-tabPanel>
        </p-tabView>
    </form>
</div>

<ng-template #formButtons>
    <form-buttons
        [saving]="savingOrganization"
        [disabled]="organizationForm.invalid || (signatureRxEnabled() && (srxCredentialsForm.invalid || srxOAuth2CredentialsForm.invalid))"
        [config]="{ cancelUrl: '/app/companies' }"></form-buttons>
</ng-template>

<p-dialog
    [(visible)]="cqcRegistrationNumberDialogVisible"
    [modal]="true"
    [draggable]="false"
    [style]="{ 'max-width': '600px', width: '100%' }"
    [closable]="false"
    header="PLEASE ENTER THE CQC REGISTRATION NUMBER">
    <form [formGroup]="organizationForm">
        <m-control-group [required]="true" label="CQC Registration Number">
            <m-text-control [formControl]="cqcRegistrationNumber"></m-text-control>
            <control-errors [control]="cqcRegistrationNumber"></control-errors>
        </m-control-group>

        <form-buttons [disabled]="cqcRegistrationNumber.invalid" [config]="cqcRegistrationButtonsConfig"></form-buttons>
    </form>
</p-dialog>
